export default state => state.vod.hodor.data;
